import React from "react";
import { makeStyles } from "@mui/styles";
import {
  Card,
  CardContent,
  Typography,
  TextField,
  InputAdornment,
  Box,
  CardHeader,
  Grid,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";
import ASPECStyles from "../../../../../styles/jss/components/apps/ASPECStyles";
import ImportData from "../ImportData";
import { cfg } from "../../../../../config";

const useStyles = makeStyles(ASPECStyles);

const WingspanBodyGeometry = (props) => {
  const status = props.status === "SUCCESSFUL";
  const tableUnlocked = props.status !== "SUCCESSFUL";
  const { data, updateData } = props;
  const classes = useStyles();

  const getValue = (args, column) => {
    if (args) {
      return args[column];
    }
    return null;
  };

  const isFieldDisabled = () => {
    return !tableUnlocked || props.isRunning || props.isSaving
  }

  const getField = (args, column, type='number', label=column, unit='') => {
    const value = getValue(args, column)
    return (
      <TextField
        type={type}
        name={`args.${column}`}
        label={label}
        fullWidth
        value={value}
        disabled={isFieldDisabled()}
        error={value ? Boolean(value.error) : false}
        focused={value ? value.focus : false}
        variant="outlined"
        size="small"
        onChange={(e) => handleChange(e)}
        style={{margin: '16px 0px 0px 0px'}}
        slotProps={{
          input: unit ? {
            endAdornment:
            <InputAdornment position="end">
              <Typography variant={'caption'} style={{ color: "rgba(0,0,0,0.54)" }}>{unit}</Typography>
            </InputAdornment>
          } : {}
        }}
      />
    );
  };

  const getCheckboxField = (args, column, section='', unit='') => {
    const value = getValue(args, column)
    console.log(value)
    return (
      <Checkbox
        color="primary"
        name={`args.${column}`}
        checked={value}
        onChange={e => handleChange(e)}
        // disabled={status}
      />
    );

  };

  const handleChange = (e) => {
    // e.preventDefault();
    const target = e.target;
    console.log(target.type)
    const name = e.target.name;
    // Get field value
    let value;
    switch (target.type) {
      case 'number':
        value = parseFloat(target.value);
        break;
      case 'checkbox':
        value = target.checked;
        break;
      default:
        value = target.value;
    }
    // Update data
    console.log("handleChange: ", value, name);
    updateData(value, name);
  };

  return (
    <Card style={{ height: "100%" }}>
      <CardHeader
        title={"Options"}
        classes={{
          title: classes.cardHeaderTitle,
          root: classes.cardHeaderRoot,
        }}
        action={
          <div>
            <ImportData
              status={status}
              isRunning={props.isRunning}
              isSaving={props.isSaving}
              refresh={props.refresh}
              updateData={props.updateData}
              aircraft={props.aircraft}
              saveDraft={props.saveDraft}
            />
          </div>
        }
      />
      <CardContent>
        <div>
          <Grid container spacing={2}>
            {/* <Grid size={{ lg: 2, md: 3, sm: 6 }} style={{padding: '8px 8px'}}>
              {getField(data.args, 'loadedRing', 'text', 'Loaded ring')}
            </Grid>
            <Grid size={{ lg: 2, md: 3, sm: 6 }} style={{padding: '8px 8px'}}>
              {getField(data.args, 'adjacentRing', 'text', 'Adjacent ring')}
            </Grid> */}
            <Grid size={{ lg: 2, md: 3, sm: 6 }} style={{padding: '16px 8px 0px 8px'}}>
              {/* <FormGroup>
                <FormControlLabel
                    control={getCheckboxField(data.args, 'legacyMode')}
                    label="Legacy mode"
                    classes={{label: classes.selectLabels}}
                    disabled={isFieldDisabled()}
                />
              </FormGroup> */}
              <FormControl
                className={classes.predefinedFormControl}
                variant="outlined"
                size="small"
                disabled={isFieldDisabled()}
                style={{width: '100%'}}
                margin={'dense'}>
                  <InputLabel id="section-flag">Section flag</InputLabel>
                  <Select
                      labelId="section-flag"
                      id="section-flag-outlined"
                      value={data.args.analysis}
                      name={'args.analysis'}
                      onChange={(e) => handleChange(e)}
                      label="Section flag"
                  >
                      {/* <MenuItem value={''}><em>Select</em></MenuItem> */}
                      <MenuItem value={3}><em>Center</em></MenuItem>
                      <MenuItem value={2}><em>Outboard</em></MenuItem>
                  </Select>
              </FormControl>
            </Grid>

            <Grid size={{ lg: 3, md: 4, sm: 6 }} style={{padding: '16px 8px 0px 8px'}}>
              <FormControl
                className={classes.predefinedFormControl}
                variant="outlined"
                size="small"
                disabled={isFieldDisabled()}
                style={{width: '100%'}}
                margin={'dense'}>
                  <InputLabel id="skin-effectivity">Skin Effectivity</InputLabel>
                  <Select
                      labelId="skin-effectivity"
                      id="skin-effectivity-outlined"
                      value={data.args.skinEffectivity}
                      name={'args.skinEffectivity'}
                      onChange={(e) => handleChange(e)}
                      label="Skin Effectivity"
                  >
                      <MenuItem value={0}><em>Actual Widths from Input File (User Calculated Effectivity)</em></MenuItem>
                      { cfg.domain === "aeronauticausa" && ( // option only available on aeronauticausa.com (hidden on govCloud)
                        (<MenuItem value={1}><em>Effective width based on Bruhn Eq C7.15</em></MenuItem>)
                      )}
                  </Select>
              </FormControl>
            </Grid>

            <Grid size={{ lg: 3, md: 4, sm: 6 }} style={{padding: '16px 8px 0px 8px'}}>
              <FormControl
                className={classes.predefinedFormControl}
                variant="outlined"
                size="small"
                disabled={isFieldDisabled()}
                style={{width: '100%'}}
                margin={'dense'}>
                  <InputLabel id="solution-method">Solution Method</InputLabel>
                  <Select
                      labelId="solution-method"
                      id="solution-method-outlined"
                      value={data.args.solutionMethod}
                      name={'args.solutionMethod'}
                      onChange={(e) => handleChange(e)}
                      label="Solution Method"
                  >
                      <MenuItem value={1}><em>Process 1 station for all Loadcases</em></MenuItem>
                      <MenuItem value={2}><em>Process all stations for 1 Loadcase</em></MenuItem>
                  </Select>
              </FormControl>
            </Grid>
          </Grid>
          {/* <Grid container spacing={2}>
            <Grid size={{ lg: 2, md: 3, sm: 6 }} style={{padding: '8px 8px'}}>
              {getField(data.args, 'shellRadius', 'number', 'Radius of shell')}
            </Grid>
            <Grid size={{ lg: 2, md: 3, sm: 6 }} style={{padding: '8px 8px'}}>
              {getField(data.args, 'ringRadius', 'number', 'Ring radius (to neutral axis)')}
            </Grid>
            <Grid size={{ lg: 2, md: 3, sm: 6 }} style={{padding: '8px 8px'}}>
              {getField(data.args, 'shellThickness', 'number', 'Thickness of shell')}
            </Grid>
            <Grid size={{ lg: 2, md: 3, sm: 6 }} style={{padding: '8px 8px'}}>
              {getField(data.args, 'ringMomentInertia', 'number', 'Ring moment of inertia')}
            </Grid>
            <Grid size={{ lg: 2, md: 3, sm: 6 }} style={{padding: '8px 8px'}}>
              {getField(data.args, 'equivalentShellThickness', 'text', 'Equivalent thickness of shell')}
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid size={{ lg: 2, md: 3, sm: 6 }} style={{padding: '8px 8px'}}>
              {getField(data.args, 'modulusElasticity', 'text', 'Modulus of elasticity')}
            </Grid>
            <Grid size={{ lg: 2, md: 3, sm: 6 }} style={{padding: '8px 8px'}}>
              {getField(data.args, 'ringSpacing', 'text', 'Ring spacing')}
            </Grid>
            <Grid size={{ lg: 2, md: 3, sm: 6 }} style={{padding: '8px 8px'}}>
              {getField(data.args, 'shearModulus', 'text', 'Shear modulus')}
            </Grid>
            <Grid size={{ lg: 2, md: 3, sm: 6 }} style={{padding: '8px 8px'}}>
              {getField(data.args, 'structuralParamA', 'text', 'Structural parameter A')}
            </Grid>
            <Grid size={{ lg: 2, md: 3, sm: 6 }} style={{padding: '8px 8px'}}>
              {getField(data.args, 'structuralParamB', 'text', 'Structural parameter B')}
            </Grid>
          </Grid> */}
        </div>
      </CardContent>
    </Card>
  );
};

export default WingspanBodyGeometry;
